export default "__VITE_ASSET__D1jPxxr$__"